package com.eladfinish.bible.contest.screens.pyramidCrossword.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Developed by
 * @author Elad Finish
 */

@Serializable
data class PyramidSheetEntry(
    @SerialName("מספר-תשבץ") val crosswordNumber: String,
    @SerialName("שאלה") val question: String,
    @SerialName("תשובה") val answer: String,
    @SerialName("מספר-אותיות") val length: String,
)

@Serializable
data class PyramidQuestion(
    @Serializable(with = IntOrStringSerializer::class)
    val number: Int = 0,
    val question: String,
    val answer: String,
) {

    val answerNoSpaces: String
        get() = answer.replace(oldValue = " ", newValue = "")

    val numberOfLettersInAnswer: Int
        get() = answerNoSpaces.length

}

@Serializable
data class PyramidJsonRoot(
    val records: List<PyramidJsonRecord> = emptyList(),
) {
    /** The pyramids as played: blank questions/answers dropped, and pyramids left empty skipped. */
    fun playableCollections(): List<List<PyramidQuestion>> =
        records.mapNotNull { record ->
            record.collection
                .filter { it.question.isNotBlank() && it.answer.isNotBlank() }
                .takeIf { it.isNotEmpty() }
        }
}

@Serializable
data class PyramidJsonRecord(
    val collection: List<PyramidQuestion> = emptyList(),
)
